import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { makeStyles } from '@material-ui/core/styles';
// import env from "../../env"
import { Typography, Grid, InputLabel, FormControl, NativeSelect } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  channel: {
    fontSize: '22px',
    color: 'black',
    fontWeight: '500'
  },
  selectChannel: {
    marginTop: '.2rem !important',
    
    "& .MuiSelect-select": {
      maxWidth: "130px",
      paddingTop: '5px',
      paddingBottom: '5px'
    },

    "& .MuiPaper-root": {
      maxHeight: '250px'
    },

    [theme.breakpoints.down("sm")]: {
      marginBottom: '20px'
    },
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
    },
  },
};

const types = [
  'Text',
  'Gambar',
  'PDF'
];

function getStyles(name, typeName, theme) {
  return {
    fontWeight:
      typeName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}


const ReportSummary = ({ overalStats, typeSelected }) => {
    const dispatch = useDispatch()
    const classes = useStyles();
    const theme = useTheme();
    const [typeName, setTypeName] = useState([]);
    
    useEffect(() => {
      typeSelected(typeName)
    }, [typeName])

    const handleChange = (event) => {
      const {
        target: { value },
      } = event;
      setTypeName(
        // On autofill we get a the stringified value.
        typeof value === 'string' ? value.split(',') : value,
      );
    };
  

    return (
        <div>
          <Grid container className={classes.contentReport}>
            <Grid item xs={12} md>
                <InputLabel variant="standard" htmlFor="uncontrolled-native" className={classes.channel}>
                  Tipe
                </InputLabel>
              <FormControl sx={{ m: 1, width: 300, mt: 3 }}>
                <Select
                  className={classes.selectChannel}
                  multiple
                  displayEmpty
                  value={typeName}
                  onChange={handleChange}
                  input={<OutlinedInput />}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <em>Semua Tipe</em>;
                    }

                    return selected.join(', ');
                  }}
                  MenuProps={MenuProps}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem disabled value="">
                    <em>Semua Tipe</em>
                  </MenuItem>
                  {types.map((type) => (
                    <MenuItem
                      key={type}
                      value={type}
                      style={getStyles(type, typeName, theme)}
                    >
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} md className="text-center">
              <Typography className="font-size-16 reguler">Total Broadcast</Typography>
              <Typography className="font-size-24 bold">
                {
                  overalStats? overalStats.totalBroadcast : 0
                }
              </Typography>
            </Grid>
            
            <Grid item xs={12} md className="text-center">
              <Typography className="font-size-16 reguler">Berhasil</Typography>
              <Typography className="font-size-24 bold text-green">
                {
                  overalStats? overalStats.totalSuccessBroadcast : 0
                }
              </Typography>
            </Grid>            
            <Grid item xs={12} md className="text-center">
              <Typography className="font-size-16 reguler">Gagal</Typography>
              <Typography className="font-size-24 bold text-red">
                {
                  overalStats? overalStats.totalFailedBroadcast : 0
                }
              </Typography>
            </Grid>

            <Grid item xs={12} md className="text-center">
              <Typography className="font-size-16 reguler">Pending</Typography>
              <Typography className="font-size-24 bold">
                {
                  overalStats? overalStats.totalPendingBroadcast : 0
                }
              </Typography>
            </Grid>
          </Grid>
          <br/>
        </div>
    )
}

export default ReportSummary
